var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12Z",
    fill: "#24CC63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0691 9.65932L11.3297 6.78963C7.4744 4.85862 5.89205 6.44098 7.82306 10.2963L8.40638 11.4629C8.41198 11.4744 8.41739 11.4858 8.42262 11.4974H11.9258C12.2007 11.4974 12.4287 11.7253 12.4287 12.0002C12.4287 12.2751 12.2007 12.5031 11.9258 12.5031H8.42481C8.41891 12.5163 8.41277 12.5294 8.40638 12.5424L7.82306 13.7024C5.89205 17.5577 7.4677 19.14 11.3297 17.209L17.0691 14.3393C19.6438 13.052 19.6438 10.9467 17.0691 9.65932Z",
    fill: "#DFF6D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/Send.e2ffe10f0b8adcbb8be8bf62aa4f5669.svg";
export { ForwardRef as ReactComponent };